<template>
    <v-col>
        <v-col cols="12">
            <v-row>
                <v-col cols="6">
                    Mes relevés d'intempéries
                </v-col>
                <v-col cols="6" class="text-right">
                    <router-link tag="a" to="/documentsnew">Commander un relevé</router-link>
                </v-col>
            </v-row>
            <v-spacer />
        </v-col>
        <v-col>
            <!-- Datatable for display file documents -->
            <v-text-field v-model="search" rounded filled dense placeholder="Rechercher..."/>
            <v-card elevation="10" class="rounded-lg">
                <v-data-table height="65vh" :search="search" :headers="headers" :items="documents" item-key="name" sort-by="name"
                    group-by="name" class="elevation-1" >
                <template v-slot:item.action="{ item }">
                    <v-btn icon :to="`/documentsnew?raw=${item.raw_data}`"><v-icon>mdi-content-copy</v-icon></v-btn>
                    <v-btn icon v-if="item.file_url" @click="downloadFile(item.file_url)"><v-icon>mdi-share</v-icon></v-btn>
                    <template v-else>
                        <v-btn icon disabled><v-icon>mdi-share</v-icon></v-btn>
                    </template>
                </template>
                <template v-slot:item.status="{item}">
                    <v-chip :color="item.status ? 'green' : 'warning'" text-color="white">
                        {{ item.status ? 'Disponible' : 'En cours' }}
                    </v-chip>
                </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-col>
</template>

<script>
import api from '@/api';
import moment from 'moment';
import { mapState } from 'vuex';
export default {
    name: "Documents",
    computed:{
        ...mapState(['user'])
    },  
    data() {
        return {
            search:null,
            headers: [
                {
                    text: 'Chantiers',
                    align: 'start',
                    value: 'name',
                    groupable: false,
                },
                { text: 'Chantier', value: 'category', align: 'right' },
                { text: 'Date', value: 'date', align: 'right' },
                { text: 'Parametres', value: 'parametres', align: 'right' },
                { text: 'Status', value: 'status', align: 'right' },
                { text: 'Action', value: 'action', align: 'right' },
            ],
            documents: [
                // {
                //     name: 'Avignon',
                //     date: '12/12/2020 - 12/12/2022',
                //     category: 'Relevés',
                //     parametres: 'Temp.min, Temp.max',
                //     action:""
                // },
                // {
                //     name: 'Bordeaux',
                //     date: '12/12/2020 - 12/12/2022',
                //     category: 'Relevés',
                //     parametres: 'Temp.min, Temp.max',
                //     action:""
                // },
                // {
                //     name: 'Bordeaux',
                //     date: '12/12/2020 - 12/12/2022',
                //     category: 'Relevés',
                //     parametres: 'Temp.min, Temp.max',
                //     action:""
                // },

            ],
        }
    },
    methods: {
        async getDocumentsForUser(id_user) {
            let response = await api.users.getUploadedFiles(id_user);
            console.log('response',response);
            let params = ['tmax', 'tmin', 'vent', 'pluie', 'neige'];
            this.documents = [];
            response.forEach(element => {
                let document = {
                    name: element.city_name,
                    date: `${moment(element.debut).format('DD/MM/YYYY')} - ${moment(element.fin).format('DD/MM/YYYY')}` ,
                    category: 'Relevés',
                    file_url: element.file_url,
                    raw_data:JSON.stringify(element.raw_data),
                    parametres: params.filter(param => element[param] == 1).join(', '),
                    action:"",
                    status:element.valide ? true : false
                }
                this.documents.push(document);
            });
        },
        downloadFile(file_url){
            console.log(file_url);
            window.open(file_url, '_blank');
        }
    },
    mounted()
    {
        this.getDocumentsForUser(this.user.id_user);
    }
}
</script>